// Sits with the menu's own sizing rather than with the shared anchor geometry in
// `constants/popover`, because the width a menu takes from its anchor is a menu concern.
export const ANCHOR_WIDTH_PROPERTY = '--spds-menu-anchor-width';
export const MENU_ITEM_SELECTOR =
  '[role="option"], [role="menuitem"], input[type="checkbox"]:not(.select-all)';
export const MENU_MAX_HEIGHT = '368px';
export const SEARCH_INPUT_SELECTOR = '[data-test-spds-menu-search-input]';
export const SIZING_PROPERTIES = {
  maxHeight: '--spds-menu-max-height',
  maxWidth: '--spds-menu-max-width',
  minWidth: '--spds-menu-min-width',
  width: '--spds-menu-width',
};

export default {
  ANCHOR_WIDTH_PROPERTY,
  MENU_ITEM_SELECTOR,
  MENU_MAX_HEIGHT,
  SEARCH_INPUT_SELECTOR,
  SIZING_PROPERTIES,
};
